<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yowFob/tc-custom/9781949112450.jpg?1723592038491" alt="This image is the cover for the book Queen of Legacy, Academy of the Damned"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Queen of Legacy, Academy of the Damned
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Saving the Soule Coven starts with saving one statue from the academy – but its walls are impenetrable, and Madison is being hunted.</b><br/><br/>After a painful betrayal and a frightening encounter with her pursuers, Madison’s at a dead end. As she risks detection and death to pursue a Salem urban legend connected to the statues, Madison finds the clues she needs…and unravels some family secrets she never wanted to know.<br/><br/>Haunted by her discoveries, Madison realizes she and her friends can’t rival the power of La Voisin alone – but if they step aside, the entire supernatural community will be doomed. To have any hope of winning this fight, Madison must walk into a den of gods and somehow convince them to help instead of taking her life.<br/><br/>But even that might not be enough to breach the defenses of La Voisin, where deadly magic lurks darker than ever.<br/><br/><em>Fans of Stephenie Meyers’ Twilight and Bella Forrest’s Harley Merlin series will devour Veronica Shade’s Academy of the Damned series.</em><br/><br/><b>Scroll up and one-click to continue reading this slow burn paranormal academy romance today!</b><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Veronica Shade
      </h2>
      
      <p class="authorDescription body article">Veronica Shade writes fast-paced young adult and new adult paranormal romance reads. When she's not busy writing about snarky heroines and darkly dreaming vampires, she spends her time binge-watching Game of Thrones and reruns of Firefly, playing with her cats, or gaming.<br><br>Veronica’s love for writing comes second only to her love of reading. If you like her books, she recommends you also check out Bella Forrest, Kiera Cass, and Cassandra Clare.<br><br><i>The Veronica Shade pen name is a joint-venture persona of authors Rebecca Hamilton, Heather Marie Adkins, April Canavan, Anna Applegate, and Leigh Anderson.</i></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Evershade Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9d01a73c